import React, { memo, useEffect, useCallback, useState} from 'react';
import { FastLayer, Rect} from 'react-konva';
import {connect} from 'react-redux';

const BasicPoints = memo(({showColors, color, pts}) => { 
    return (
        <FastLayer>
          {pts.map(
              (pt, i) =>
                  <Rect
                    key={i}
                    x={pt.x}
                    y={pt.y}
                    width={pt.width}
                    height={pt.height}
                    fill={showColors ? 'rgb(' + pt.rgb[0] + ',' + pt.rgb[1] + ',' + pt.rgb[2] + ')' :
                          color}/>)}
        </FastLayer>);
});

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicPoints);
